export class Logger {
  public static allowLog: boolean = false;

  public static log(...args: any[]) {
    if (Logger.allowLog) {
      const time: string = new Date().toLocaleTimeString();
      let passingArgs: any[] = [time + ' -->'];
      passingArgs = passingArgs.concat(args);
      console.log.apply(console, passingArgs);
    }
  }
}
